import React, { useCallback } from "react";
import { Checkbox } from "@alm/flow-ds/components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SelectFieldsType } from "hooks/FormDesigner/useElementList";

interface Props {
	selectFieldsBasedOnForm: boolean;
	updateSelectFieldsBasedOnForm: (data: SelectFieldsType) => void;
	isEmu: boolean;
}

const SelectFieldsBasedOnForm = ({
	selectFieldsBasedOnForm,
	updateSelectFieldsBasedOnForm,
	isEmu,
}: Props) => {
	const [selectFields, setSelectFields] = useState<boolean>(
		selectFieldsBasedOnForm || false
	);

	const { t } = useTranslation();

	const handleChange = useCallback(() => {
		setSelectFields(!selectFields);
		updateSelectFieldsBasedOnForm({ value: !selectFields, isEmu: isEmu });
	}, [isEmu, selectFields, updateSelectFieldsBasedOnForm]);

	return (
		<Checkbox
			id="select-fields"
			label={t("formDesigner.labels.selectFields")}
			onChange={handleChange}
			value={selectFields.toString()}
			checked={selectFields}
			hint={t("formDesigner.labels.selectFieldsHint")}
		/>
	);
};

export default SelectFieldsBasedOnForm;
